import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download } from "lucide-react";

export const QrShareCard = () => {
  const url = `${window.location.origin}/momentos`;
  const wrapRef = useRef(null);

  const download = () => {
    const canvas = wrapRef.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = "qr-momentos-boda.png";
    a.click();
  };

  return (
    <div
      data-testid="qr-share-card"
      className="bg-cream border border-clay/15 rounded-3xl p-8 flex flex-col sm:flex-row items-center gap-8"
    >
      <div ref={wrapRef} className="bg-white p-4 rounded-2xl border border-clay/10 shrink-0">
        <QRCodeCanvas value={url} size={150} fgColor="#2A2522" bgColor="#FFFFFF" level="M" includeMargin={false} />
      </div>
      <div className="text-center sm:text-left">
        <p className="text-[11px] uppercase tracking-[0.3em] text-stone">QR para los invitados</p>
        <p className="mt-3 text-sm text-stone leading-relaxed">
          Imprime este código y ponlo en las mesas el día de la boda. Al escanearlo, tus invitados escriben su nombre y
          pueden tomar fotos y videos desde su celular que aparecen al instante en la galería.
        </p>
        <p className="mt-3 font-mono text-xs text-clay break-all">{url}</p>
        <button
          data-testid="qr-download-button"
          onClick={download}
          className="mt-5 rounded-full border border-clay text-clay px-6 py-3 text-[11px] uppercase tracking-[0.25em] hover:bg-clay hover:text-cream transition-colors inline-flex items-center gap-2"
        >
          <Download size={14} /> Descargar QR
        </button>
      </div>
    </div>
  );
};
